import { Error, TrashCan } from "@carbon/icons-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import useInboundDeliveryByIdQuery from "../../../../hooks/graphql-hooks/queries/useInboundDeliveryByIdQuery";
import { InboundDeliveryItemFragment } from "../../../../models/autogenerated-deliveryService-gql/graphql";
import { TimeSlotBooking } from "../../../../models/timeSlotBooking";
import PageLoader from "../../../PageLoader";
import FallbackComponent from "../../../fallbackComponent/FallbackComponent";
import AlertDialog from "../../AlertDialog";
import CheckBoxListTimeSlotBookings from "./CheckBoxListTimeSlotItem";

export interface CancelTimeSlotAlertDialogProps {
  deliveryId: string;
  showDialog: boolean;
  selectedOptions: TimeSlotBooking[];
  loading: boolean;
  setShowDialog: (show: boolean) => void;
  handleConfirm: () => void;
  onCheckBoxChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    option: TimeSlotBooking,
  ) => void;
}

const CancelTimeSlotAlertDialog = (props: CancelTimeSlotAlertDialogProps) => {
  const { t } = useTranslation();
  const {
    deliveryId,
    showDialog,
    selectedOptions,
    loading,
    setShowDialog,
    handleConfirm,
    onCheckBoxChange,
  } = props;

  const [inboundDeliveryItems, setInboundDeliveryItems] = useState<
    InboundDeliveryItemFragment[]
  >([]);

  const { loading: loadingQuery, error } = useInboundDeliveryByIdQuery({
    id: deliveryId,
    dataAction: (data) => {
      setInboundDeliveryItems(data.items);
    },
  });

  const renderBody = () => {
    if (error)
      return (
        <FallbackComponent
          middleIcon={<Error size={32} />}
          text={t("deliveryDetailsError")}
        />
      );

    if (loadingQuery || !inboundDeliveryItems) return <PageLoader />;

    return (
      <>
        <div className="alert-dialog-container-body-reasons-list">
          <CheckBoxListTimeSlotBookings
            inboundDeliveryItems={inboundDeliveryItems}
            selectedOptions={selectedOptions}
            onCheckBoxChange={onCheckBoxChange}
          />
        </div>
      </>
    );
  };

  return (
    <div>
      <AlertDialog
        showDialog={showDialog}
        setShowDialog={() => setShowDialog(false)}
        headerLogo={
          <TrashCan
            className="alert-dialog-container-head-alert-header-top-half-mid-ellipse-icon"
            size={32}
          />
        }
        title={t("cancelTimeSlot") + "?"}
        description={t("cancelTimeSlotAlertDialogDescription")}
        confirmButtonText={t("confirmCancelTimeSlot")}
        cancelButtonText={t("no")}
        handleConfirm={handleConfirm}
        type="warning"
        confirmButtonDisabled={loading || selectedOptions.length === 0}
        isLoading={loading}
      >
        {renderBody()}
      </AlertDialog>
    </div>
  );
};

export default CancelTimeSlotAlertDialog;
